
import { inject, Injectable } from "@angular/core";
import { ApiService } from "@tylertech/core-module";
import { ExecutionResult, ILegacyLookupService, LookupCriteria, TransactionCodeViewModel } from "@tylertech/tyler-api-types";

/**
 * TransactionCodeLookupService is a generated service implementation. Any edits will be overridden!
 */
@Injectable()
export class TransactionCodeLookupService {
    private readonly $apiService = inject(ApiService);
    
    Lookup(pCriteria: LookupCriteria): Promise<ExecutionResult<TransactionCodeViewModel[]>> {
        return this.$apiService.sendAuth("ITransactionCodeLookupService/Lookup", pCriteria);
    }
}
